import request from './api';
import {
  API_ACCESS_CONTROL,
  API_CREATE_EXCEL_ACCESS_CONTROL,
  API_PAYROLL
} from '../constants/api';

export const getImputedDays = () =>
  request(`${API_ACCESS_CONTROL}`, {
    method: 'GET'
  });

export const getImputedDaysOnScroll = (employeeId, from, to, page, size) =>
  request(
    `${API_ACCESS_CONTROL}?employeeId=${employeeId}&fromDate=${from}&toDate=${to}&page=${page}&size=${size}`,
    {
      method: 'GET'
    }
  );

export const getExcelImputedDaysOnScroll = (employeeId, from, to) => {
  const url = `${API_CREATE_EXCEL_ACCESS_CONTROL}?employeeId=${employeeId}&fromDate=${from}&toDate=${to}`;

  return request(url, {
    method: 'GET',
    responseType: 'blob'
  });
};

export const getExcelImputedDaysOnScrolls = (employeeId, from, to) =>
  request(
    API_CREATE_EXCEL_ACCESS_CONTROL,
    {
      method: 'GET',
      responseType: 'blob',
      params: {
        employeeId,
        from,
        to
      }
    },
    false
  );

export const getImputedDaysByDate = (employeeId, from, to) =>
  request(
    `${API_ACCESS_CONTROL}?employeeId=${employeeId}&fromDate=${from}&toDate=${to}`,
    {
      method: 'GET'
    }
  );

export const getCurrentImputedDay = () =>
  request(`${API_ACCESS_CONTROL}/today`, {
    method: 'GET'
  });

export const postImputationTime = detail =>
  request(`${API_ACCESS_CONTROL}`, {
    method: 'POST',
    data: {
      ...detail
    }
  });

export const putImputationTime = detail =>
  request(`${API_ACCESS_CONTROL}`, {
    method: 'PUT',
    data: {
      ...detail
    }
  });

export const getManagedUsers = () =>
  request(`${API_ACCESS_CONTROL}/managedUsers`, {
    method: 'GET'
  });

export const getManagedUsersPayslips = () =>
  request(`${API_PAYROLL}/managedUsers`, {
    method: 'GET'
  });
